// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3Gvm0","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3cYK9"};